// extracted by mini-css-extract-plugin
export default {"contents":"bankTransfer_contents__3EhIi","cardcontainer":"bankTransfer_cardcontainer__XdM9r","submitbutton":"bankTransfer_submitbutton__eX8dC"};